var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTackle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.293 8.4C14.2961 8.33281 14.2992 8.26406 14.2992 8.2C14.2992 5.11719 11.4617 2.59531 7.89922 2.41719V0H7.09922V2.41719C3.53672 2.59531 0.699219 5.11719 0.699219 8.2C0.699219 8.26406 0.702344 8.33281 0.705469 8.4H0.699219C0.699219 8.42969 0.707031 8.45938 0.708594 8.48906C0.891407 11.4844 3.79141 17.1391 7.09922 17.5719V20H7.89922V17.5719C11.207 17.1391 14.107 11.4844 14.2898 8.48906C14.2914 8.45938 14.2992 8.42969 14.2992 8.4H14.293ZM7.49922 16.8C5.18828 16.8 2.63672 13.0344 1.79141 10.0297C2.95078 10.7625 4.96484 11.2 7.49922 11.2C10.0336 11.2 12.0477 10.7625 13.207 10.0297C12.3602 13.0344 9.81016 16.8 7.49922 16.8Z",
    fill: "#272A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTackle);
export default __webpack_public_path__ + "static/media/tackle.0fabb1edda063ef972164b3a80c9f816.svg";
export { ForwardRef as ReactComponent };